import React, { useState } from 'react';
import { BsCalendar2WeekFill } from "react-icons/bs";
import { FaPlus } from 'react-icons/fa';
import { BsFillCalendarPlusFill } from "react-icons/bs";
import { Button, Form, Alert, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './holidays.css';

export default function AddHoliday() {
  const [holidayName, setHolidayName] = useState('');
  const [date, setDate] = useState('');
  const [payRate, setPayRate] = useState(0);
  const [counter, setCounter] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = Math.max(0, Number(e.target.value));
    setCounter(value);
    setPayRate(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const holidayData = {
      holidayName,
      date,
      payRate,
    };

    try {
      const response = await fetch('https://backend.ems.hiradentallab.com/api/holidays/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(holidayData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Public holiday added:', result);
        setShowAlert(true);
        setTimeout(() => {
          navigate('/public-holidays');
        }, 2000);
        setHolidayName('');
        setDate('');
        setCounter(0);
      } else {
        console.error('Failed to add public holiday');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className='container-fluid'>
      <h1 className='holiday-title'>
        <BsCalendar2WeekFill style={{ marginRight: '5px' }} />
        Public Holidays 
      </h1>
      <hr />
      <h1 className='holiday-subtitle'>
        <BsFillCalendarPlusFill style={{ marginRight: '5px' }} />
        Add Holiday
      </h1>
      <hr />
      {showAlert && (
        <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
          <Alert.Heading>Holiday Added Successfully!</Alert.Heading>
        </Alert>
      )}
      <div className='edit-holiday-content'>
        <Form className='holiday-form' onSubmit={handleSubmit}>
          <Row className='form-row'>
            <Col md={4}>
              <Form.Group controlId='holiday-date'>
                <Form.Label>Date<span className='required'>*</span></Form.Label>
                <Form.Control
                  type='date'
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={4}>
              <Form.Group controlId='holiday-name'>
                <Form.Label>Holiday Name<span className='required'>*</span></Form.Label>
                <Form.Control
                  type='text'
                  value={holidayName}
                  onChange={(e) => setHolidayName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group controlId='holiday-counter'>
                <Form.Label>Pay Rate<span className='required'>*</span></Form.Label>
                <Form.Control
                  type='number'
                  value={counter}
                  onChange={handleChange}
                  min='0'
                  step='1'
                />
              </Form.Group>
            </Col>
          </Row>
          <div className='button-content'>
            <Button type='submit' variant='success'><FaPlus className='add-holiday-icon' /> Add Holiday</Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
